import { useTranslation } from 'react-i18next';
import { ServiceArea } from '@bringg/types';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import { useStores } from 'bringg-web/recipes';
import { Button } from 'bringg-web/components';

import './table.scss';

export const ActionsCell = ({
	record,
	openConfirmationModal,
	onEdit
}: {
	record: ServiceArea;
	openConfirmationModal: (record: ServiceArea) => void;
	onEdit: (record: ServiceArea) => void;
}) => {
	const { t } = useTranslation();
	const {
		usersStore: { isAdmin },
		teamsStore: { teams }
	} = useStores();

	const belongToUnknownTeams = isAdmin ? false : record.team_ids.some(id => !teams.has(id));

	return (
		<>
			<Button type="link" onClick={() => onEdit(record)}>
				<BringgIcon iconName={BringgFontIcons.Pencil} />
				{t('SERVICE_AREA.EDIT')}
			</Button>
			{belongToUnknownTeams ? null : (
				<Button type="link" danger onClick={() => openConfirmationModal(record)}>
					<BringgIcon iconName={BringgFontIcons.Trash} />
					{t('SERVICE_AREA.DELETE')}
				</Button>
			)}
		</>
	);
};
